<form [formGroup]="variableValueForm">

  <ng-container *ngIf="displayAutocomplete(); else noAutocomplete">
    <input select-all #tooltip="matTooltip" #input
           [matTooltip]="getTooltipErrorMessage()"
           matTooltipPosition="below" matTooltipClass="tooltip-error" formControlName="variableValue"
           [placeholder]="variable.defaultValue" type="text" [matAutocomplete]="possibleValuesAutoComplete"
           #trigger="matAutocompleteTrigger">
    <mat-autocomplete #possibleValuesAutoComplete="matAutocomplete" #matAutocomplete>
      <mat-option *ngFor="let option of filterPossibleValues()" [value]="option">
        {{option}}
      </mat-option>
    </mat-autocomplete>
  </ng-container>

  <ng-template #noAutocomplete>
    <input select-all #tooltip="matTooltip" #input [matTooltip]="getTooltipErrorMessage()" matTooltipPosition="below"
           matTooltipClass="tooltip-error"
           [placeholder]="variable.defaultValue" formControlName="variableValue" type="text"
           (keydown.enter)="enterUpdate($event)"
           (blur)="onUpdate($event)">
  </ng-template>

</form>
